import {
  GetAppointmentPaymentListActionTypes,
  GET_APPOINTMENT_PAYMENT_LIST_FAIL,
  GET_APPOINTMENT_PAYMENT_LIST_LOADING,
  GET_APPOINTMENT_PAYMENT_LIST_SUCCESS,
  GetAppointmentPaymentListState,
  GET_APPOINTMENT_PAYMENT_LIST_UPDATE_API_MSG,
  GET_APPOINTMENT_PAYMENT_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { GetAppointmentPaymentListRes } from "./Model";

const initialStateGetPosts: GetAppointmentPaymentListState = {
  loading: false,
  getAppointmentPaymentListRes: {} as GetAppointmentPaymentListRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getAppointmentPaymentListReducer = (
  state = initialStateGetPosts,
  action: GetAppointmentPaymentListActionTypes
): GetAppointmentPaymentListState => {
  switch (action.type) {
    case GET_APPOINTMENT_PAYMENT_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_APPOINTMENT_PAYMENT_LIST_SUCCESS:
      return {
        ...state,
        getAppointmentPaymentListRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_APPOINTMENT_PAYMENT_LIST_FAIL:
      return {
        ...state,
        getAppointmentPaymentListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_APPOINTMENT_PAYMENT_LIST_UPDATE_API_MSG:
      return {
        ...state,
        getAppointmentPaymentListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_APPOINTMENT_PAYMENT_LIST_UPDATE_API_RES:
      return {
        ...state,
        getAppointmentPaymentListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
